import React from 'react';
import Navigation from 'src/components/navigation/navigation';
import NavigationLayout from 'src/components/navigation/navigation-layout';
import { useLocation } from "react-router-dom";

const NavigationPage: React.FC = () => {
  const location = useLocation();
  const state = location.state as { referrer?: string } | null;

  return (
    <NavigationLayout children={<Navigation />} referrer={state?.referrer}></NavigationLayout>
  );
};

export default NavigationPage;